<template>
  <div :class="['overlay-pop']">
    <div class="item-view overlay-pop--box" :class="[readytime ? 'ready' : '']">
      <transition name="fade-scaled">
        <a
          v-if="gallery.active"
          @click.prevent="gallery.active = false"
          :class="['closebtn', closing ? 'closing' : '']"
        ></a>
        <router-link
          v-else
          @click.native="close"
          :to="pathback"
          :class="['closebtn', closing ? 'closing' : '']"
        ></router-link>
      </transition>
      <transition name="overlay-up" appear>
        <keep-alive>
          <content-gallery
            v-if="gallery.active"
            :image="currentItem.image"
            :attachments="gallery.attachments"
            :title="currentItem.title"
            :desc="currentItem.description"
            :activeIndex="gallery.index"
            :id="currentItem._id"
          >
            <a
              href="#p"
              slot="close"
              @click.prevent="closeGallery"
              class="closebtn"
            ></a>
          </content-gallery>
        </keep-alive>
      </transition>
      <!-- <a href="#p" :to="pathback" :class="['closebtn', closing ? 'closing' : '']" @click.prevent="close"></a> -->

      <div v-if="currentItem" class="info">
        <div :class="['preview-image', activeRelated ? 'related-active' : '']">
          <template v-if="!closing && currentItem.platform">
            <template v-if="typeof currentItem.platform !== 'string'">
              <div
                v-for="platform in currentItem.platform"
                :key="platform"
                :class="['wt', 'item-platform', parsePlatform(platform)]"
              >
                <span v-text="parsePlatform(platform, true)"></span>
              </div>
            </template>
            <div
              v-else
              :class="['item-platform', parsePlatform(currentItem.platform)]"
            >
              <span v-text="parsePlatform(currentItem.platform, true)"></span>
            </div>
          </template>
          <img
            :src="currentItem.image"
            :alt="currentItem.title"
            :title="currentItem.title"
          />
        </div>
        <div :class="['info-col', activeRelated ? 'related' : '']">
          <!-- <transition name="fade-scaled"> -->
          <transition-group
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
            appear
          >
            <div :key="1" v-if="!activeRelated" class="title">
              <h5 class="item-cat">{{ currentItem.cat }}</h5>
              <h3>{{ currentItem.title }}</h3>
            </div>
            <!-- <div class="description" v-html="currentItem.description"></div> -->
            <div
              :key="2"
              class="product-prop"
              v-if="!activeRelated && currentItem.volume"
            >
              <h5 v-text="'Volume:'"></h5>
              <!--translate('Volume', $appTranslations)-->
              <span v-html="`${currentItem.volume}cc`"></span>
            </div>
            <div
              :key="3"
              class="product-prop"
              v-if="!activeRelated && currentItem.membrane_size"
            >
              <h5 v-text="'Membrane Size:'"></h5>
              <span v-html="currentItem.membrane_size"></span>
            </div>
            <div
              :key="4"
              class="product-prop"
              v-if="!activeRelated && hasDimensions(currentItem)"
            >
              <h5
                class="normal-case"
                v-text="localize('dimensions') + ':'"
              ></h5>
              <span v-html="parseDimensions(currentItem, localize)"></span>
            </div>
            <div
              :key="5"
              class="product-prop"
              v-if="!activeRelated && currentItem.implant_type"
            >
              <h5 v-text="localize('implant_type') + ':'"></h5>
              <span v-html="parseToString(currentItem.implant_type)"></span>
            </div>
            <div
              :key="6"
              class="product-prop"
              v-if="!activeRelated && currentItem.restoration_type"
            >
              <h5 v-text="localize('Restoration Type') + ':'"></h5>
              <span v-html="parseToString(currentItem.restoration_type)"></span>
            </div>
            <div
              :key="7"
              class="product-prop"
              v-if="!activeRelated && currentItem.material"
            >
              <h5 v-text="localize('material') + ':'"></h5>
              <span v-html="parseToString(currentItem.material)"></span>
            </div>
            <div
              :key="8"
              class="product-prop"
              v-if="!activeRelated && currentItem.ncm"
            >
              <h5 v-text="localize('Tightening Force') + ':'"></h5>
              <span v-html="`${parseToString(currentItem.ncm)}Ncm`"></span>
            </div>
            <div :key="9" v-if="!activeRelated" class="item-links">
              <preloader
                :title="localize('loading_additional')"
                v-if="!relatedLoaded"
                class="inline mt-xl"
              ></preloader>
              <ul v-else>
                <li
                  class="item-link"
                  v-for="attachment in currentItem.attachments"
                  :key="attachment.label"
                  @click.prevent="attachmentHandler(attachment)"
                >
                  <abtn :icon="`fas fa-${attachment.type}`" mini>
                    <!-- <i :class="['icon-' + attachment.type]"></i> -->
                    <span v-text="attachment.label"></span>
                  </abtn>
                </li>
                <li
                  class="item-link"
                  @click.prevent="toggleRelatedItems(true)"
                  v-if="relatedItems && relatedItems.length"
                >
                  <abtn icon="far fa-clone" href="#p" mini>
                    <!-- <i class="far fa-clone"></i> -->
                    <span v-text="localize('items_included')"></span>
                  </abtn>
                </li>
              </ul>
            </div>
            <a
              v-if="activeRelated"
              key="backb"
              href="#p"
              :class="['back-btn', 'show']"
              @click.prevent="toggleRelatedItems(false)"
            >
              <i class="fas fa-chevron-left"></i
              ><span v-text="localize('back')"></span>
            </a>
            <grid-items
              v-if="activeRelated"
              key="relatedgrid"
              limited
              :with-actions="false"
              grid-type="catalog"
              :paginateditems="relatedItems"
            ></grid-items>
          </transition-group>
        </div>
        <!-- <div v-else :class="['info-col', 'related']">
              
            </div> -->
      </div>
      <preloader v-else-if="!closing"></preloader>
    </div>
  </div>
</template>
<script>
// vuex
import { mapActions, mapState } from "vuex";
import { storage } from "@/utils";

// plugins
// import Velocity from "velocity-animate";
// components
import GridItems from "@/components/grid/GridItems.vue";
import ContentGallery from "./ContentGallery.vue";

import { parseDimensions, hasDimensions, parseToString } from "@/utils";
export default {
  props: {
    currentItem: {
      type: Object,
      required: true
    },
    attr: {
      type: [Object, Array],
      required: true
    },
    filtersHash: {
      type: [Object, Array],
      required: true
    }
  },
  data() {
    return {
      closing: false,
      totalItems: 0,
      gallery: {
        active: false,
        attachments: null,
        index: -1
      },
      readytime: false,
      activeRelated: false,
      defaultImage: "scientific/articles/rl_12.png",
      relatedItems: null,
      parseDimensions,
      parseToString,
      hasDimensions,
      relatedLoaded: false
    };
  },
  // head: {
  // 	title() {
  // 		return {
  // 			inner: this.title
  // 		}
  // 	},
  // 	meta() {
  // 		return [
  // 			{ property: 'og:image', content: `http://www.mis-implants.com/upload/${this.image}`},
  // 			{ property: 'og:title', content: this.title},
  // 			{ property: 'og:image:type', content: 'image/jpeg'},
  // 			{ property: 'og:description', content: this.description },
  // 		]
  // 	},
  // },
  watch: {
    currentItem() {
      // if (!!this.currentItem) {
      // console.log('current item > ', this.currentItem);
      this.fetchAdditionalItemData();
      // }
    }
  },
  components: {
    ContentGallery,
    GridItems
  },

  activated() {
    // console.log("currenitem >> ", this.currentItem);
    this.init();
  },
  mounted() {
    // console.log("mounted VITEM >> ", this.currentItem);
    this.init();
  },
  computed: {
    ...mapState(["defaultItemBg", "relatedProducts", "locale"]),
    $locale() {
      return this.$route.params.locale || this.$defaultLang;
    },
    // relatedItems() {
    //   return this.relatedProducts;
    //   // return !!vm.currentItem.related ? _.filter(vm.items, item => vm.currentItem.related.indexOf(item._id)>-1) : [];
    // },
    // title() {
    //     return !!this.currentItem ? this.currentItem.Tit : 'Mis Implants'
    // },
    // image() {
    //     return !!this.currentItem ? this.currentItem.Ico : this.defaultImage
    // },
    // description() {
    //     return !!this.currentItem ? this.currentItem.Des : 'Mis Implants research implantology'
    // },
    pathback() {
      let search = window.location.search,
        currentpath = this.$route.path,
        path = currentpath.slice(0, currentpath.lastIndexOf("/")) + search;
      return { path };
      // this.$router.go({path})
    }
    // PRODUCTION() {
    //   return PRODUCTION;
    // }
  },
  asyncComputed: {
    imageStyle() {
      let item = this.currentItem;
      if (item) {
        // let vm = this;
        return new Promise(resolve => {
          let img = document.createElement("img");
          img.addEventListener("load", function() {
            resolve(`background-image:url(${item.image})`);
          });
          img.addEventListener("error", function() {
            resolve(
              // "background-image:url(" +
              //   vm.defaultItemBg +
              //   "); background-size: 50%"
              "background:black"
            );
          });
          img.src = item.image;
        });
      }
      return "";
    }
  },
  methods: {
    close() {
      this.toggleRelatedItems(false);
      this.closing = true;
    },
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateX(-50%)";
    },
    enter: function(el, done) {
      let lapse = 120,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateX(-50%)", "translateX(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateX(-120%)";
      done();
    },
    async init() {
      // console.log("INIT> ", this.currentItem);
      setTimeout(
        function() {
          this.closing = false;
        }.bind(this),
        1000
      );
      setTimeout(
        function() {
          this.readytime = true;
          // console.log("ITEM VIEW READY TIME");
          this.fetchAdditionalItemData();
        }.bind(this),
        1000
      );
    },
    fetchAdditionalItemData: _.debounce(function() {
      this.$nextTick(async function() {
        if (this.currentItem) {
          this.populateAttachments();

          console.log("this.relatedItems > ", this.relatedItems);
          if (!this.relatedItems) {
            this.$set(this, "relatedLoaded", false);
          }
          this.relatedItems = await this.fetchRelatedItems(
            this.currentItem.productId
          );
          this.$set(this, "relatedLoaded", true);
        }
      });
    }, 1200),
    async fetchRelatedItems(id) {
      let ln,
        cc,
        vm = this;
      // console.log("fetchRelatedItems > ", id);
      // active cache?
      let useCache = vm.$useCache["productRelated"];
      return new Promise(resolve => {
        // locale keys
        ({ ln, cc } = this.locale);
        let storageKey = `relatedProducts-${id}`,
          relatedFromStorage = storage.get(storageKey);
        console.log("relatedFromStorage > ", relatedFromStorage);
        if (!relatedFromStorage) {
          fetch(`https://api.mis-implants.com/api/productsIncluded/${id}`, {
            headers: {
              ln,
              cc
            }
          })
            .then(function(response) {
              return response.json();
            })
            .then(async function(json) {
              console.log("JSON > ", json);
              let related = await vm.parseItems(json);
              useCache && storage.set(storageKey, related);
              // console.log("commit [fetch!!] RELATED_PRODUCTS ", related);
              resolve(related);
            });
        } else {
          resolve(JSON.parse(relatedFromStorage));
        }
      });
    },
    async parseItems(items) {
      let vm = this,
        filtersHash = this.filtersHash,
        _attributes = this.attr;
      return new Promise(resolve => {
        let _items = items.map(function(item) {
          let attr_item = _.filter(
            _attributes,
            attr => attr[2] === item.PRO_ID
          );
          // console.log("attr_item >> ", attr_item);

          var obj = {
            _id: item.Id,
            productId: item.PRO_ID,
            cat: item.CatalogNo,
            title: item.ShortName,
            description: item.Description,
            // image: `${vm.$imageFolder}/catalog/products/large/${item.CatalogNo}.png`,
            image: `${vm.$imageFolder}/catalog/products/thumbs/${item.CatalogNo}.png`,

            attachments: []
          };

          Object.assign(
            obj,
            _.reduce(
              attr_item,
              (_obj, at) => {
                let key,
                  val,
                  val2,
                  _filterItem = _.find(
                    filtersHash,
                    f => parseInt(f.type) === parseInt(at[0])
                  );
                if (_filterItem) {
                  key = _filterItem.name.toLowerCase().replace(" ", "_");
                  if (at[3] && !_.isNull(at[3]) && at[3] > 0) {
                    val = at[3];
                  } else if (at[1] && at[1] > 0) {
                    let _filterVal = _.find(_filterItem.filters, ff => {
                      return parseInt(ff.id) === parseInt(at[1]);
                    });
                    if (_filterVal) {
                      val = _filterVal.label || _filterVal.name;
                      // Hold the name for when english label is needed...
                      val2 = _filterVal.name;
                    }
                  }
                  if (key && val) {
                    if (_obj.hasOwnProperty(key)) {
                      // item already has this prop,
                      // make into array and make multiple
                      if (typeof _obj[key] === "string") {
                        _obj[key] = [_obj[key]];
                        if (key === "platform") {
                          _obj["platform_eng"] = [_obj["platform_eng"]];
                        }
                      }
                      if (_.isNumber(_obj[key].length)) {
                        _obj[key].push(val);
                        if (key === "platform") {
                          _obj["platform_eng"].push(val2);
                        }
                      }
                    } else {
                      _obj[key] = val;
                      if (key === "platform") {
                        _obj["platform_eng"] = val2;
                      }
                    }
                  }
                }
                return _obj;
              },
              {}
            )
          );
          if (item.MediaVideo) {
            obj.attachments.push({
              label: vm.localize("video"),
              link: item.MediaVideo,
              type: "video"
            });
          }
          if (item.PrintCatalog) {
            obj.attachments.push({
              label: "PDF",
              link: `http://www.mis-implants.com/upload/${item.PrintCatalog}`,
              type: "file-pdf"
            });
          }
          return obj;
        });
        console.log("_items > ", _items);
        let finalitems = _.uniqBy(_items, "productId");
        console.log("finalitems > ", finalitems);
        resolve(finalitems);
      });
    },
    parsePlatform(platform, label) {
      // console.log("PARSEPLT  ITEM > ", platform, label);
      let _case;
      if (typeof platform === "string") {
        _case = platform.split(" ")[0];
      } else {
        _case = platform.platform_eng.split(" ")[0];
      }
      switch (_case) {
        case "Standard":
          return label ? `${platform}` : "item-platform--sp";
        case "Wide":
          return label ? `${platform}` : "item-platform--wp";
        case "Narrow":
          return label ? `${platform}` : "item-platform--np";
      }
    },
    toggleRelatedItems(bool) {
      // console.log('related >> ', this.relatedItems);
      this.activeRelated = bool;
    },
    populateAttachments() {
      if (this.currentItem && this.currentItem.attachments) {
        let att = _.filter(
          this.currentItem.attachments,
          att => att.type != "pdf"
        );
        this.gallery.attachments = att;
        this.addDownloadPDFToIssue();
        return att;
      }
    },
    addDownloadPDFToIssue() {
      if (this.currentItem.Pdf) {
        let issue = _.find(this.gallery.attachments, { type: "issue" });
        if (issue) {
          issue.download = this.linkify(this.currentItem.Pdf);
        }
      }
    },
    linkify(link) {
      return /http/.test(link)
        ? link
        : `http://www.mis-implants.com/upload/${link}`;
    },
    attachmentHandler(attachment) {
      let type = attachment.type,
        attachments = this.gallery.attachments || this.populateAttachments();

      if (/pdf/i.test(type)) {
        let url = this.linkify(attachment.link);
        window.open(url);
        return;
      }
      this.openGallery(attachments, type);
    },
    openGallery(attachments, type) {
      this.gallery.index = _.findIndex(attachments, { type });
      this.gallery.active = true;
    },
    closeGallery() {
      this.gallery.active = false;
    }
  }
};
</script>
<style lang="stylus" scoped>
.fade
  &-enter-active
  &-leave-active
    transition opacity 0.6s ease-out, transform 0.6s ease-out-back
  &-enter
  &-leave-to
    opacity 0 !important
    transform translateX(100%) !important
  &-enter-to
  &-leave
    opacity 1 !important
    transform translateX(0) !important

.back-btn,
.back-btn:visited
    color #a5a6a8
    font-size responsive 16px 18px
    line-height 1
    position absolute -10% false false 0
    opacity 0
    transform translateX(20%)
    will-change opacity, transform
    &.show
        opacity 1
        transform translateY(0)
        transition opacity 0.2s 0.4s ease-out, transform 0.2s 0.4s ease-out
    span,i
        display inline-block
        vertical-align middle
        line-height 1
        text-transform uppercase
    span
        color gray_8
    i
        color gray_8
        font-size 85%
        position relative
        transform translateX(-50%)
        transition color 0.2s ease
.item-view
  +below(600px, orientation: portrait)
    .closebtn
      top 10px
      right 10px
  &.in-dev
      top 0
  h2
      color #fff
  & > .info
      opacity 0
      transition opacity 0.2s
  &.ready > *
      opacity 1
.product-prop
  margin-bottom 20px
  h6
      width 100%
      margin 0
  h5
    font-size 14px
    color gray_6
    text-transform uppercase
  span
    color gray_9
    font-size responsive 18px 22px
    display block
    padding 0

.item-view
  .title
      position relative
      z-index 21
      padding-bottom 2vh
      margin-bottom 3vh
      &:after
        content ''
        position absolute
        bottom 0
        left 0
        height 1px
        width 50%
        background gray_5
        +below(600px, orientation: portrait)
          width 100%

      h4
        font-weight 200
        &:nth-child(2)
          text-transform uppercase
            // text-shadow 1px 1px 2px rgba(0,0,0,0.8)
        &.item-cat
            margin-bottom 5px
            line-height 1
      h5
        font-weight 200
  .item-platform
    position absolute
    top 5vh
    right auto
    left 0
    transform translate3d(0,0,0)
    padding 0 14px
    border-radius 50px
    border 2px solid transparent
    opacity 0.96
    width auto
    background rgba(#fff, 0.9)
    & + .item-platform
      margin-top 40px
    span
        font-size responsive 13px 16px
        position static
        white-space nowrap
        text-transform capitalize
        line-height 26px
        span
          color gray_6
    &--np
      border-color #ffd200
    &--sp
        border-color #c47fb4
    &--wp
        border-color #22b24c
  .info
      width 90%
      max-width 1100px
      margin 0 auto
      padding 5% 0
      height 100%
      word-spacing 0
      white-space nowrap
      _flex(row, nowrap, center, center)
      text-align left
      +below(815px, orientation: landscape)
        padding 3% 0 0
      +below(600px, orientation: portrait)
          display flex
          flex-direction column
          white-space normal
          height 99%
          & > *
              width 80% !important
              margin 2vh auto
              min-width initial  !important
              min-height initial !important
              height auto !important
              flex 100%
      .preview-image
          position relative
          _flex(row, nowrap, center, center, inline)
          max-width 600px
          transform translateX(0)
          transition transform 1s ease-out-back
          &.related-active
            transition transform 1s ease-out-cubic
            transform translateX(-5%)
          img
            max-width 75%
            max-height 55vh
            +below(815px, orientation: landscape)
              max-height 75vh
            +below(600px)
              max-height 33vh
      & > *
          display inline-block
          vertical-align top
          min-height 54vh
          white-space normal
          +below(1024px)
              min-height 48vh
      & > :first-child
              flex 1
              +below(600px, orientation: portrait)
                flex 0 0 42%
              .circle-item
                  margin 0
                  padding-top @width
                  background-repeat no-repeat
                  background-size 101%
                  // border-radius 100%
                  background-position 50% 50%
                  position relative
                  // box-shadow 2px 2px 12px #000
                  +below(1024px)
                      width 70%
                      padding-top @width
                  +below(600px, orientation: portrait)
                      margin 0 auto
      & > .info-col
          // border-left 1px solid #494949
          flex none
          &.related
            flex 0 0 50%
          position relative
          will-change width, padding
          transition width 0.4s ease-out, padding 0.4s ease-out
          +below(815px, orientation: landscape)
            height 100%
            overflow auto
          +below(600px, orientation: portrait)
              border 0
              // border-top 1px solid #494949
              padding 2vh 0
              margin-top 2vh
              max-height 42vh
              overflow auto
              &.related
                padding 36px 0
              .back-btn
                top 7px
                left 6px

          *
              opacity 1
              transition opacity 0.2s
          &.related-active
              width 0
              padding-left 0
              padding-right 0
              +below(550px, orientation: portrait)
                  height 0 !important
              *
                  opacity 0
      .item-links
        padding-top 10vh
        .item-link
            display inline-block
            line-height 1
            margin 5px 5px 0 0
            &:last-child
              margin-right 0
        +below(900px)
          padding-top 1vh
        +below(600px, orientation: portrait)

          pad('xl', top)
        a
            inline-mid(bottom)
            // color blue
            transition color 200ms ease
            text-decoration none
            +below(550px, orientation: portrait)
                inline-mid(sub)
            span
                text-decoration underline
            i
                margin-right 5px
            &:hover
                color #01cefd
</style>
